import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { makeFetchSuccessActionType } from '../../event/fetchActionTypeProvider';
import { HttpStatusCode } from '../../fetch/core/constant';
import { sendGlobalEvent } from '../../utils/emit';
import ActionType from '../action/control';
const initialState: any = {
  terminalList: null,
  downloadList: null,
};

const controlState = createSlice({
  name: 'control',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        makeFetchSuccessActionType(ActionType.REMOTE_CONTROL_POWER_REBOOT),
        (state, action: any) => {
          const response = action.payload;
          if (response.code === HttpStatusCode.Success) {
            sendGlobalEvent('POWER_OFF_SUCCESS', response);
          }
        },
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.REMOTE_CONTROL_POWER_OFF),
        (state, action: any) => {
          const response = action.payload;
          if (response.code === HttpStatusCode.Success) {
            sendGlobalEvent('POWER_OFF_SUCCESS', response);
          }
        },
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.REMOTE_WEB_TERMINAL_TOOL),
        (state, action: any) => {
          const response = action.payload;
          if (response.code === HttpStatusCode.Success) {
            state.terminalList = response.data;
          }
        },
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.WEB_TERMINAL_COMMAND_DATA),
        (state, action: any) => {
          const response = action.payload;
          const { messageType, data } = response.data;
          if (messageType === 'VEHICLE_TO_SERVER_FILE') {
            // 拉取下载文件列表
            const downloadList =
              data &&
              data.map(
                (i: {
                  downloadUrl: string;
                  fileName: string;
                  processProgress: number;
                }) => ({
                  enable: i.processProgress == 100,
                  fileName: i.fileName,
                  downloadUrl: i.downloadUrl,
                }),
              );
            state.downloadList = downloadList;
          }
        },
      );
  },
});

export default controlState.reducer;
